import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '72px 0',
        [theme.breakpoints.down('md')]: {
            padding: '40px 0',
            paddingTop: 0,
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        }
    },
    ctnImage: {
        '& > img': {
            objectFit: 'contain',
            [theme.breakpoints.up('md')]: {
                height: 600,
                width: 'auto',
                maxWidth: '100%',
            }
        },
        // Reserve fixed slot so slide changes don't shift layout
        [theme.breakpoints.up('md')]: {
            minHeight: 600,
            backgroundImage: `url('/static/new-landing-page/become-member/desktop/background_gradient.webp')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left -50px center',
            backgroundSize: 'cover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: 96,
        },
        [theme.breakpoints.up(1400)]: {
            paddingRight: 160,
            backgroundPosition: 'left 0px center',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '0 auto',
            minHeight: '90vw',
            maxHeight: 480,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& > img': {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
            }
        },
    },
    ctnContent: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        paddingLeft: 96,
        [theme.breakpoints.up(1400)]: {
            paddingLeft: 190,
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            paddingLeft: 24,
            paddingRight: 24,
            alignItems: 'center',
            marginTop: 6
        },
    },
    title: {
        marginTop: 0,
        fontSize: 48,
        fontWeight: 800,
        color: '#fff',
        lineHeight: '56px',
        marginBottom: '24px',
        [theme.breakpoints.down('md')]: {
            fontSize: 30,
            lineHeight: '40px',
            textAlign: 'center',
        }
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
        '& > img': {
            width: 32,
            height: 32,
            marginRight: 16
        },
        '& > span': {
            fontSize: 20,
            fontWeight: 500,
            color: '#fff',
        },
        '&:not(:first-child)': {
            marginTop: 24
        },
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'translateX(8px)',
        },
        [theme.breakpoints.down('md')]: {
            '& > span': {
                fontSize: 18,
            },
            '& > img': {
                width: 20,
                height: 20,
            }
        }
    },
    activeItem: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        borderLeft: '4px solid #007bff',
        paddingLeft: '12px',
        '& > span': {
            fontWeight: '700',
        }
    },
    ctnChecklist: {
        marginBottom: 24
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        maxWidth: 740,
        [theme.breakpoints.down('md')]: {
            alignItems: 'center',
        }
    },
    desktopContent: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
            width: '100%',
        }
    },
    mobileContent: {
        [theme.breakpoints.down('md')]: {
            display: 'block',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        }
    },
    ctnButton: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            '& > button': {
                width: '100%',
            }
        }
    }
}));

export default useStyles;